import React from 'react'

import { compose } from 'redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
	progresscontainer: {
		display: 'flex',
		flexDirection: 'column',
		height: 'auto',
		marginRight: 'auto',
		marginBottom: '1rem',
		marginLeft: 'auto',
		width: '100%'
	},

	progress: {
		borderRadius: '0.625rem',
		height: '3rem',
		width: '100%'
	},

	labelcontainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%'
	},

	labelLeft: {
		alignItems: 'flex-start',
		color: '#152456',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: '0.875rem',
		paddingRight: '0.5rem',
		paddingTop: '0.5rem',
		textAlign: 'left'
	},

	labelRight: {
		alignItems: 'flex-end',
		color: '#152456',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: '0.875rem',
		paddingTop: '0.5rem',
		paddingLeft: '0.5rem',
		textAlign: 'right'
	},

	sublabel: {
		color: '#c0c8dc',
		fontSize: '0.875rem',
		paddingTop: '0.5rem'
	},

	colorDotOne: {
		backgroundColor: '#152456',
		borderRadius: '50%',
		display: 'inline-block',
		height: '0.5rem',
		width: '0.5rem'
	},

	colorDotTwo: {
		backgroundColor: '#c0c8dc',
		borderRadius: '50%',
		display: 'inline-block',
		height: '0.5rem',
		width: '0.5rem'
	}
})

function Results({ classes, optionOnePercentage, optionOne, optionTwo, t }) {
	return (
		<div className={classes.progresscontainer}>
			<div
				className={classes.progress}
				style={{
					background: `linear-gradient(
			90deg,
			#152456ba,
			#152456ba ${optionOnePercentage}%,
			#c0c8dc ${optionOnePercentage}%,
			#c0c8dc`
				}}
			/>
			<div className={classes.labelcontainer}>
				<div className={classes.labelLeft}>
					<div>
						<span className={classes.colorDotOne}></span> {t('Option', {OPTIONNUM: 1})} (
						{`${parseInt(optionOnePercentage, 10)}`}%)
					</div>
					<div className={classes.sublabel}>{optionOne}</div>
				</div>
				<div className={classes.labelRight}>
					<div>
						<span className={classes.colorDotTwo}></span> {t('Option', {OPTIONNUM: 2})} (
						{`${100 - parseInt(optionOnePercentage, 10)}`}%)
					</div>
					<div className={classes.sublabel}>{optionTwo}</div>
				</div>
			</div>
		</div>
	)
}

export default compose(translate(), withStyles(styles))(Results)



// WEBPACK FOOTER //
// ./src/components/counseling-session/report/Results.js